import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  if (String(location.pathname || "").includes("/payment/callback")) {
    return <Navigate to={`/pg-payout/history${location.search}`} replace />;
  }

  return (
    <div className="flex h-screen items-center justify-center flex-col">
      <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
      <Link to="/" className="text-blue-500 mt-3">Go Home</Link>
    </div>
  );
};

export default NotFound;